/**
 * Vue Router configuration
 */

import { createRouter, createWebHistory } from 'vue-router';
import ExplorerView from '@/views/ExplorerView.vue';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/WelcomeView.vue'),
    },
    {
      path: '/blueprint',
      name: 'blueprint',
      component: () => import('@/views/BlueprintView.vue'),
    },
    {
      path: '/char-graph',
      name: 'char-graph',
      component: () => import('@/views/UniversalGraphView.vue'),
    },
    {
      path: '/explorer',
      name: 'explorer',
      component: ExplorerView,
    },
    {
      path: '/explorer/:domain?/:sectionId?',
      name: 'explorer-section',
      component: ExplorerView,
      props: true,
    },
    {
      path: '/explore',
      name: 'explore',
      component: () => import('@/components/explorer/explore/ExploreView.vue'),
    },
    {
      path: '/crosswalk',
      name: 'framework-crosswalk',
      component: () => import('@/components/explorer/FrameworkCrosswalk.vue'),
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import('@/views/PrivacyView.vue'),
    },
  ],
});

export default router;
